import { render, staticRenderFns } from "./HuskyPay.vue?vue&type=template&id=50bdc979"
import script from "./HuskyPay.vue?vue&type=script&lang=js"
export * from "./HuskyPay.vue?vue&type=script&lang=js"
import style0 from "./HuskyPay.vue?vue&type=style&index=0&id=50bdc979&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports